import { render, staticRenderFns } from "./adPackage.vue?vue&type=template&id=dbc875dc&scoped=true&"
import script from "./adPackage.vue?vue&type=script&lang=js&"
export * from "./adPackage.vue?vue&type=script&lang=js&"
import style0 from "./adPackage.vue?vue&type=style&index=0&id=dbc875dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbc875dc",
  null
  
)

export default component.exports